export default "__VITE_ASSET__CLv4CG2j__"